import { render, staticRenderFns } from "./BaseButtonWarning.vue?vue&type=template&id=6347b42d&"
import script from "./BaseButtonWarning.vue?vue&type=script&lang=js&"
export * from "./BaseButtonWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports